import React, { useState } from "react";
import { getCookie } from '../utils/csrf';

// const API_BASE = "https://hopeful-cosmic-koala.ngrok-free.app/api";
const API_BASE = "/api";

const Join = () => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    country: "",
    gender: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess]   = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage]     = useState("");

  const genderChoices = [
    { value: "",                 label: "Select Gender" },
    { value: "male",             label: "Male" },
    { value: "female",           label: "Female" },
    { value: "other",            label: "Other" },
    { value: "prefer_not_to_say", label: "Prefer not to say" },
  ];

  const countries = [
    { value: "",               label: "Select Country" },
    { value: "Uganda",         label: "Uganda" },
    { value: "Kenya",          label: "Kenya" },
    { value: "Tanzania",       label: "Tanzania" },
    { value: "Rwanda",         label: "Rwanda" },
    { value: "Burundi",        label: "Burundi" },
    { value: "South Sudan",    label: "South Sudan" },
    { value: "United States",  label: "United States" },
    { value: "United Kingdom", label: "United Kingdom" },
    { value: "Canada",         label: "Canada" },
    { value: "Other",          label: "Other" },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrorMessage("");

    try {
      const res = await fetch(`${API_BASE}/join/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "69420",
          "X-CSRFToken": getCookie("csrftoken"),
        },
        body: JSON.stringify(formData),
      });

      if (res.status === 201) {
        const data = await res.json();
        setSuccessMessage(data.detail || "Registration successful! We'll be in touch soon.");
        setShowSuccess(true);
        setFormData({
          first_name: "", last_name: "", email: "",
          phone_number: "", country: "", gender: "",
        });
      } else {
        const data = await res.json();
        // Surface first Django validation error
        const firstField  = Object.keys(data)?.[0];
        const firstErrors = data[firstField];
        const msg = Array.isArray(firstErrors) ? firstErrors[0] : "Something went wrong. Please try again.";
        setErrorMessage(msg);
      }
    } catch (err) {
      console.error("Join submit error:", err);
      setErrorMessage("Could not submit your registration. Please check your connection and try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet" />
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css" />

      <div className="join-page">

        {/* HERO */}
        <section className="join-hero" style={{
          backgroundImage: "url('/images/2.png')",
          backgroundSize: "cover",
          backgroundPosition: "center top",
          backgroundRepeat: "no-repeat",
        }}>
          <div className="hero-overlay">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-10 text-center text-white">
                  <h1 className="display-3 fw-bold mb-3">Join Our Community</h1>
                  <p className="fs-5 mb-4">Come, witness and prove the practical truth of God's reality.</p>
                  <p className="lead mb-0">
                   
                  
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* REGISTRATION FORM */}
        <section className="py-5 bg-light">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="card border-0 shadow-lg rounded-4">
                  <div className="card-body p-5">
                    <div className="text-center mb-5">
                      <div className="mb-3">
                        <i className="bi bi-person-plus-fill fs-1 text-primary"></i>
                      </div>
                      <h2 className="fw-bold text-primary mb-2">Membership Registration</h2>
                      <p className="text-muted mb-0">
                        Fill in the form below to join GCCI as a church member. All fields are required.
                      </p>
                    </div>

                    {/* Error banner */}
                    {errorMessage && (
                      <div className="alert alert-danger border-0 rounded-3 mb-4">
                        <i className="bi bi-exclamation-circle me-2"></i>
                        {errorMessage}
                      </div>
                    )}

                    <form onSubmit={handleSubmit}>
                      {/* Name */}
                      <div className="row g-3 mb-4">
                        <div className="col-md-6">
                          <label className="form-label fw-bold">
                            First Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-lg rounded-3"
                            name="first_name"
                            value={formData.first_name}
                            onChange={handleChange}
                            placeholder="Enter your first name"
                            required
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label fw-bold">
                            Last Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-lg rounded-3"
                            name="last_name"
                            value={formData.last_name}
                            onChange={handleChange}
                            placeholder="Enter your last name"
                            required
                          />
                        </div>
                      </div>

                      {/* Email */}
                      <div className="mb-4">
                        <label className="form-label fw-bold">
                          Email Address <span className="text-danger">*</span>
                        </label>
                        <div className="input-group input-group-lg">
                          <span className="input-group-text bg-light border-end-0 rounded-start-3">
                            <i className="bi bi-envelope text-primary"></i>
                          </span>
                          <input
                            type="email"
                            className="form-control border-start-0 rounded-end-3"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="your.email@example.com"
                            required
                          />
                        </div>
                        <small className="text-muted">We'll use this to contact you and send updates</small>
                      </div>

                      {/* Phone */}
                      <div className="mb-4">
                        <label className="form-label fw-bold">
                          Phone Number <span className="text-danger">*</span>
                        </label>
                        <div className="input-group input-group-lg">
                          <span className="input-group-text bg-light border-end-0 rounded-start-3">
                            <i className="bi bi-telephone text-primary"></i>
                          </span>
                          <input
                            type="tel"
                            className="form-control border-start-0 rounded-end-3"
                            name="phone_number"
                            value={formData.phone_number}
                            onChange={handleChange}
                            placeholder="+256 700 000 000"
                            required
                          />
                        </div>
                        <small className="text-muted">Include country code (e.g., +256 for Uganda)</small>
                      </div>

                      {/* Country + Gender */}
                      <div className="row g-3 mb-4">
                        <div className="col-md-6">
                          <label className="form-label fw-bold">
                            Country <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select form-select-lg rounded-3"
                            name="country"
                            value={formData.country}
                            onChange={handleChange}
                            required
                          >
                            {countries.map((c) => (
                              <option key={c.value} value={c.value}>{c.label}</option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-6">
                          <label className="form-label fw-bold">
                            Gender <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select form-select-lg rounded-3"
                            name="gender"
                            value={formData.gender}
                            onChange={handleChange}
                            required
                          >
                            {genderChoices.map((g) => (
                              <option key={g.value} value={g.value}>{g.label}</option>
                            ))}
                          </select>
                        </div>
                      </div>

                      {/* Info */}
                      <div className="alert alert-info border-0 rounded-3 mb-4">
                        <i className="bi bi-info-circle me-2"></i>
                        Your information will be reviewed by our team. You will receive a confirmation once your membership is approved.
                      </div>

                      {/* Submit */}
                      <button
                        type="submit"
                        className="btn btn-primary btn-lg rounded-pill w-100 py-3"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Submitting...
                          </>
                        ) : (
                          <>
                            <i className="bi bi-check-circle me-2"></i>
                            Submit Registration
                          </>
                        )}
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* SUCCESS MODAL */}
        {showSuccess && (
          <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content border-0 shadow-lg rounded-4">
                <div className="modal-body p-5 text-center">
                  <div className="mb-4">
                    <i className="bi bi-check-circle-fill text-success" style={{ fontSize: "80px" }}></i>
                  </div>
                  <h3 className="fw-bold text-primary mb-3">Registration Successful!</h3>
                  <p className="text-muted mb-4">{successMessage}</p>
                  <button
                    className="btn btn-primary rounded-pill px-5"
                    onClick={() => setShowSuccess(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* BENEFITS */}
        <section className="py-5 bg-white">
          <div className="container">
            <div className="text-center mb-5">
              <h2 className="display-5 fw-bold text-primary mb-3">Membership Benefits</h2>
              <p className="text-muted fs-6">Join our growing family and enjoy these benefits</p>
            </div>
            <div className="row g-4">
              {[
                { icon: "bi-heart-fill", title: "Spiritual Growth", text: "Emulating God, prayer meetings, and spiritual development programs designed to strengthen your faith." },
                { icon: "bi-people-fill", title: "Community", text: "Connect with fellow believers through fellowship groups, events, and ministry opportunities." },
                { icon: "bi-star-fill", title: "Care & Support", text: "Receive pastoral care, counseling services, and support during life's challenges and celebrations." },
              ].map((b) => (
                <div className="col-md-4" key={b.title}>
                  <div className="card border-0 shadow-sm rounded-4 h-100 p-4 text-center">
                    <div className="mb-3">
                      <i className={`bi ${b.icon} text-primary`} style={{ fontSize: "48px" }}></i>
                    </div>
                    <h5 className="fw-bold text-primary mb-3">{b.title}</h5>
                    <p className="text-muted mb-0">{b.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* SOCIAL */}
        <section className="social-section py-5 text-center text-white">
          <div className="container py-4">
            <h2 className="display-5 fw-bold mb-3">Follow Us</h2>
            <p className="fs-6 mb-4 mx-auto" style={{ maxWidth: "600px" }}>
              Stay connected with Gospel City Church International through our social platforms.
            </p>
            <div className="d-flex justify-content-center gap-3 flex-wrap">
              <a href="https://www.linkedin.com/in/gospel-city-church-international-650a562a0/" target="_blank" rel="noopener noreferrer" className="btn btn-outline-light rounded-circle social-icon"><i className="bi bi-linkedin fs-4"></i></a>
              <a href="https://groups.imo.im/.5l9akqTOrYa5Tv4T4" target="_blank" rel="noopener noreferrer" className="btn btn-outline-light rounded-circle social-icon">
            <i className="bi bi-chat-dots fs-4"></i></a>
              <a href="https://x.com/GospelCityChur?t=x8dsFbFkghmYh02lV0FVxQ&s=03" target="_blank" rel="noopener noreferrer" className="btn btn-outline-light rounded-circle social-icon"><i className="bi bi-twitter-x fs-4"></i></a>
              <a href="https://whatsapp.com/channel/0029Vb769UyDzgTBAZZcb40F" target="_blank" rel="noopener noreferrer" className="btn btn-outline-light rounded-circle social-icon"><i className="bi bi-whatsapp fs-4"></i></a>
              <a href="https://youtube.com/@gospelcitychurchinternational?si=1pZx2ak4ss3b4HuU" target="_blank" rel="noopener noreferrer" className="btn btn-outline-light rounded-circle social-icon"><i className="bi bi-youtube fs-4"></i></a>
            </div>
          </div>
        </section>

        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Lexend:wght@300;400;500;600;700;800&display=swap');
          * { font-family: 'Lexend', sans-serif; }

          .join-hero { position: relative; background-image: url('/images/choir1.jpg'); background-size: cover; background-position: center; min-height: 450px; display: flex; align-items: center; }
          .hero-overlay { position: relative; width: 100%; z-index: 2; padding: 80px 0; }
          .join-hero::before { content: ''; position: absolute; inset: 0; background: linear-gradient(135deg, rgba(11,28,107,0.95), rgba(21,158,236,0.85)); z-index: 1; }

          .form-control:focus, .form-select:focus { border-color: #1a3aa1; box-shadow: 0 0 0 0.25rem rgba(26,58,161,0.25); }
          .input-group-text { background-color: #f8f9fa; }

          .modal { animation: fadeIn 0.3s ease; }
          @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }

          .text-primary  { color: #1a3aa1 !important; }
          .text-info     { color: #159EEC !important; }
          .bg-info       { background-color: #159EEC !important; }
          .bg-primary    { background-color: #0b1c6b !important; }
          .btn-primary   { background: #0b1c6b; border-color: #0b1c6b; }
          .btn-primary:hover { background: #159EEC; border-color: #159EEC; }
          .btn-primary:disabled { background: #6c757d; border-color: #6c757d; }
          .btn-outline-primary { color: #0b1c6b; border-color: #0b1c6b; }
          .btn-outline-primary:hover { background: #0b1c6b; border-color: #0b1c6b; color: #fff; }

          .social-section { background: linear-gradient(135deg, #0b1c6b, #159EEC); }
          .social-icon { width: 52px; height: 52px; display: flex; align-items: center; justify-content: center; transition: all 0.3s; }
          .social-icon:hover { background: rgba(255,255,255,0.3); transform: translateY(-4px) scale(1.1); }

          @media (max-width: 768px) {
            .join-hero { min-height: 400px; }
            .display-3 { font-size: 2.5rem; }
          }
        `}</style>
      </div>
    </>
  );
};

export default Join;